import React, { useEffect, useState } from 'react';
import { Form, message } from 'antd';
import * as CommonService from '../../../services/CommonService';
import { BRAND_ENDPOINT, PRODUCT_ENDPOINT, PRODUCT_TYPE_ENDPOINT, WARRANTY_POLICY } from '../../../services/endpoint';
import { useHistory } from 'react-router-dom';

const WarrantyClaimCardCreate = (props) => {

	const history = useHistory();

	const { callback, onExit } = props;

	const [productType, setProductType] = useState([]);
	const [brands, setBrands] = useState([]);
	const [warranties, setWarranties] = useState([]);
	const [imeiList, setImeiList] = useState([]);
	const [existedImeiList, setExistedImeiList] = useState([]);
	const [isNormal, setIsNormal] = React.useState(false);

	useEffect(() => {
		const init = async () => {
			const apiList = [
				await CommonService.get(PRODUCT_TYPE_ENDPOINT, {}),
				await CommonService.get(BRAND_ENDPOINT, {}),
				await CommonService.get(WARRANTY_POLICY, {})
			];
			const resp = Promise.all(apiList);
			const [productTypeRes, brandRes, warrantyRes] = await resp;
			setBrands(brandRes.data || []);
			setProductType(productTypeRes.data || []);
			setWarranties(warrantyRes.data || []);
			window.setLoading(false);
		};
		window.setLoading(true);
		init();
	}, []);


	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				console.log('Received values of form: ', values);
				const body = {
					...values,
					weight: `${values.weight} ${values.weightUnit}`,
					imei: imeiList,
					isNormal
				};
				delete body.weightUnit;
				console.log('body', body);
				window.setLoading(true);
				CommonService.create(PRODUCT_ENDPOINT, body).then(res => {
					message.success('Thêm mới thành công');
					if (callback) {
						callback(res, props.form);
						return;
					}
					back();
				}).catch(err => {
					if (err?.data?.message === 'IMEI_ALREADY_EXISTS') {
						message.error('Những IMEI được bôi đỏ đã tồn tại trên hệ thống, vui lòng xóa để tiếp tục');
						setExistedImeiList(err?.data?.data || []);
					}
				})
					.finally(() => {
						window.setLoading(false);
					});
			}
		});
	};

	const back = () => {
		history.push('/product');
	};

	return (
		<div id={'product-create-page'}>
			CREATE
			{/*<Form layout={'vertical'}>*/}
			{/*	<Row gutter={12}>*/}
			{/*		<Col sm={16}>*/}
			{/*			<Row>*/}
			{/*				<Information form={props.form}*/}
			{/*										 imeiList={imeiList}*/}
			{/*										 setImeiList={setImeiList}*/}
			{/*										 isNormalProduct={isNormal}*/}
			{/*										 setIsNormalProduct={setIsNormal}*/}
			{/*										 existedImeiList={existedImeiList}*/}
			{/*				/>*/}
			{/*			</Row>*/}
			{/*			<br />*/}
			{/*			<Row>*/}
			{/*				<ProductPrice form={props.form} />*/}
			{/*			</Row>*/}
			{/*		</Col>*/}
			{/*		<Col sm={8}>*/}
			{/*			<AdditionalInformation form={props.form}*/}
			{/*														 productType={productType}*/}
			{/*														 setProductType={setProductType}*/}
			{/*														 brands={brands}*/}
			{/*														 setBrands={setBrands}*/}
			{/*														 warranties={warranties}*/}
			{/*														 setWarranties={setWarranties}*/}
			{/*			/>*/}
			{/*		</Col>*/}
			{/*	</Row>*/}
			{/*	<div className={'btn-group'}>*/}
			{/*		<Button type={'ghost'} onClick={() => onExit ? onExit(props.form) : back}>Thoát</Button>*/}
			{/*		<Button type={'primary'} onClick={handleSubmit}>Thêm sản phẩm</Button>*/}
			{/*	</div>*/}
			{/*</Form>*/}
		</div>
	);
};

export default Form.create({ name: 'WarrantyClaimCardCreate' })(WarrantyClaimCardCreate);

